// This must be kept in sync with the models on the backend
export enum RichTextEditorCommentType {
  NARRATIVE = 'NARRATIVE',
}
